import Marquee from "react-fast-marquee";

export const EditorialMarquee = () => (
  <section data-testid="marquee" className="py-10 border-y border-white/10 bg-[#050505]">
    <Marquee speed={40} gradient={false} className="overflow-hidden">
      {Array.from({ length: 3 }).map((_, i) => (
        <span key={i} className="flex items-center">
          {["Software Development", "Cloud & DevOps", "IT Consulting", "Managed Support"].map((t) => (
            <span key={t} className="flex items-center">
              <span className="font-display font-black text-5xl sm:text-7xl uppercase text-stroke px-6">
                {t}
              </span>
              <span className="text-cyan-500 text-4xl px-2">✦</span>
            </span>
          ))}
        </span>
      ))}
    </Marquee>
  </section>
);
